import { apiPostFiles } from '../../apiUtils';
import { API_URL } from '../../utils/apiUrl';

/** Atributy přílohy, které API bere jako query parametry uploadu. */
export interface AttachmentUploadAttributes {
  name?: string | null;
  description?: string | null;
  categoryId?: number | null;
}

/**
 * Nahraje jeden soubor jako přílohu entity. Prázdné atributy se neposílají - název pak
 * BE odvodí z názvu souboru.
 */
export const uploadAttachment = async (
  entityName: string,
  entityId: number,
  file: File,
  attributes: AttachmentUploadAttributes = {},
) => {
  const data = new FormData();
  data.append('files', file);

  const params = new URLSearchParams({ entity: entityName, entityId: String(entityId) });
  if (attributes.name) params.append('name', attributes.name);
  if (attributes.description) params.append('description', attributes.description);
  if (attributes.categoryId) params.append('attachmentCategoryId', String(attributes.categoryId));

  const response = await apiPostFiles({
    url: `${API_URL.FILE_UPLOAD}?${params.toString()}`,
    data,
    config: { headers: { 'Content-Type': 'multipart/form-data' } },
  });

  return !!response;
};
